var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",class:[
    'focus:outline-none box-border items-center text-center',
    _vm.linkTrackSelector,
    _vm.typeProp.class[_vm.type],
    _vm.sizeProp.class[_vm.size],
    _vm.colorProp.class[_vm.type][_vm.color],
  ],style:({ ..._vm.sizeProp.style[_vm.size] }),attrs:{"href":_vm.tag === 'a' ? _vm.href : null},on:{"click":_vm.onClick}},[_vm._t("default"),_vm._v(" "),(_vm.iconNameRight && !_vm.isPending)?_c(_vm.iconNameRight,{tag:"component",staticClass:"inline ml-10"}):_vm._e(),_vm._v(" "),(_vm.isPending)?_c('three-dots',{tag:"component",class:[
      'inline ml-10 w-25',
      { 'w-30': _vm.size === 'l' },
      { 'w-25': _vm.size === 's' || _vm.size === 'm' },
      { 'w-20': !_vm.size },
    ]}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }